// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"addToNewDeck_fullWidth__51S_L"};